module.exports = __webpack_public_path__ + "static/media/coloriconlogo.133eaed0.png";